import i18n from 'config/i18n';
import { QualificationResponse } from 'generated';
import * as yup from 'yup';

import { getLocale } from 'utils/date';

const addActivitySchema = () => {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup.object({
    name: yup
      .string()
      .trim()
      .required(t('validationFieldRequired', { name: t('name') })),
    code: yup
      .string()
      .trim()
      .required(t('validationFieldRequired', { name: t('code') })),
    description: yup.string().notRequired(),
    qualifications: yup
      .array()
      .of(yup.mixed<QualificationResponse>())
      .notRequired()
  });
};

export default addActivitySchema;
